// LooksLikesContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import { db } from '../utils/firebaseConfig';
import { useAuth } from './AuthContext';
import {
  collection,
  query,
  where,
  onSnapshot,
  addDoc,
  getDocs,
  deleteDoc
} from 'firebase/firestore';

const LooksLikesContext = createContext();

export const LooksLikesProvider = ({ children }) => {
  const { currentUser } = useAuth();               // <- same hook you already use
  const [userLikes, setUserLikes] = useState([]);  // array of post IDs the user liked

  /* ------- realtime listener for *this* user's likes ------- */
  useEffect(() => {
    let unsubscribe = () => {};
    if (currentUser) {
      const q = query(
        collection(db, 'looksLikes'),
        where('userId', '==', currentUser.uid)
      );
      unsubscribe = onSnapshot(q, snap =>
        setUserLikes(snap.docs.map(d => d.data().postId))
      );
    }
    return () => unsubscribe();
  }, [currentUser]);

  /* ------- helper fns used by LooksPost / LooksPostPage ------- */
  const addLike = async postId => {
    if (!currentUser) return;
    await addDoc(collection(db, 'looksLikes'), {
      userId: currentUser.uid,
      postId,
      timestamp: new Date()
    });
  };

  const removeLike = async postId => {
    if (!currentUser) return;
    const q = query(
      collection(db, 'looksLikes'),
      where('postId', '==', postId),
      where('userId', '==', currentUser.uid)
    );
    const snap = await getDocs(q);
    const likeDoc = snap.docs[0];
    if (likeDoc) await deleteDoc(likeDoc.ref);
  };

  return (
    <LooksLikesContext.Provider value={{ userLikes, addLike, removeLike }}>
      {children}
    </LooksLikesContext.Provider>
  );
};

export const useLooksLikes = () => useContext(LooksLikesContext);
